'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTest$002dPage$0024 from "./presto.-Test-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_TestPageView$() {
}
export { $c_Lpresto_TestPageView$ as $c_Lpresto_TestPageView$ };
$p = $c_Lpresto_TestPageView$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TestPageView$;
/** @constructor */
function $h_Lpresto_TestPageView$() {
}
export { $h_Lpresto_TestPageView$ as $h_Lpresto_TestPageView$ };
$h_Lpresto_TestPageView$.prototype = $p;
$p.ij = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_Route$().go($j_presto$002e$002dTest$002dPage$0024.$m_Lpresto_TestPage$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lurldsl_language_PathSegment__$div__Lurldsl_language_PathSegment__Lapp_tulz_tuplez_Composition__Lurldsl_language_PathSegment($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_package$().d9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lurldsl_language_PathSegmentImpl__unaryPathSegment__O__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_language_PathSegment($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_waypoint_package$(), "test", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_vocabulary_FromString$().bG(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_vocabulary_Printer$().bD()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lapp_tulz_tuplez_Composition$$anon$67()), "");
});
var $d_Lpresto_TestPageView$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TestPageView$, "presto.TestPageView$", ({
  St: 1
}));
export { $d_Lpresto_TestPageView$ as $d_Lpresto_TestPageView$ };
var $n_Lpresto_TestPageView$;
function $m_Lpresto_TestPageView$() {
  if ((!$n_Lpresto_TestPageView$)) {
    $n_Lpresto_TestPageView$ = new $c_Lpresto_TestPageView$();
  }
  return $n_Lpresto_TestPageView$;
}
export { $m_Lpresto_TestPageView$ as $m_Lpresto_TestPageView$ };
//# sourceMappingURL=presto.-Test-Page-View$.js.map
